
import { computed, defineComponent, onBeforeMount, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// types
import { ProposalT } from '@/core/types/proposal.types'

// validation
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isCreate: {
            type: Boolean,
            default: false,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        isDelete: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<ProposalT>,
            default: null,
        },
    },
    emits: ['create', 'update', 'delete', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            id: null as number | null,
            name: null as string | null,
            phoneNumber: null as string | null,
        })

        let state_form$ = useVuelidate(
            {
                name: { required },
                phoneNumber: { required }
            },
            state
        )

        const modalTitle = computed(() => {
            if (props.isCreate) return 'Добавление заявки'
            if (props.isUpdate) return 'Редактирование заявки'
            if (props.isDelete) return 'Удаление заявки'
            return 'modal title'
        })

        const modalConfirmButtonText = computed(() => {
            if (props.isCreate) return 'Добавить'
            if (props.isUpdate) return 'Редактировать'
            if (props.isDelete) return 'Удалить'
            return 'Подтвердить'
        })

        onBeforeMount(() => {
            if (!props.initialValue) return

            state.id = props.initialValue.id
            state.name = props.initialValue.name
            state.phoneNumber = props.initialValue.phoneNumber
        })

        const emitCreate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('create', toRaw(state))
        }

        const emitUpdate = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('update', { id: state.id, payload: toRaw(state) })
        }

        const emitDelete = () => {
            emit('delete', state.id)
        }

        const emitCancel = () => {
            emit('cancel')
        }

        const emitManager = () => {
            if (props.isCreate) emitCreate()
            if (props.isUpdate) emitUpdate()
            if (props.isDelete) emitDelete()
        }

        return {
            state,
            state_form$,
            modalTitle,
            modalConfirmButtonText,
            emitCancel,
            emitManager,
        }
    },
})
